import { useState, useCallback } from "react";
import instance from "../utils/AxiosConfiguration";

type FetchError = Error & { status?: number; body?: unknown };

function useFetch<Type>()
{
    const [data, setData] = useState<Type>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<FetchError | null>(null);

    const request = useCallback(async (url: string, method: 'get' = 'get') => {
        setLoading(true);
        setError(null);
        try
        {
            const data = await instance[method]<Type, Type>(url);
            setData(data);
        }
        catch (error)
        {
            const ax = error as { response?: { status?: number; data?: unknown }; message?: string };
            const err: FetchError = new Error(ax?.message || 'Unknown error occurred');
            err.status = ax?.response?.status;
            err.body = ax?.response?.data;
            setError(err);
            console.error('API Error:', err.message);
            return false;
        }
        finally
        {
            setLoading(false);
        }

        return true;
    }, []);

    return { request, data, error, loading };
}

export default useFetch